import { createVNode } from "vue";
import LeftOutlined from '@ant-design/icons-vue/LeftOutlined';
import RightOutlined from '@ant-design/icons-vue/RightOutlined';
import Button from '../button';

function noop() {}

var Operation = function Operation(_, _ref) {
  var attrs = _ref.attrs;
  var disabled = attrs.disabled,
      _attrs$moveToLeft = attrs.moveToLeft,
      moveToLeft = _attrs$moveToLeft === void 0 ? noop : _attrs$moveToLeft,
      _attrs$moveToRight = attrs.moveToRight,
      moveToRight = _attrs$moveToRight === void 0 ? noop : _attrs$moveToRight,
      _attrs$leftArrowText = attrs.leftArrowText,
      leftArrowText = _attrs$leftArrowText === void 0 ? '' : _attrs$leftArrowText,
      _attrs$rightArrowText = attrs.rightArrowText,
      rightArrowText = _attrs$rightArrowText === void 0 ? '' : _attrs$rightArrowText,
      leftActive = attrs.leftActive,
      rightActive = attrs.rightActive,
      className = attrs.class,
      style = attrs.style;
  return createVNode("div", {
    "class": className,
    "style": style
  }, [createVNode(Button, {
    "type": "primary",
    "size": "small",
    "disabled": disabled || !rightActive,
    "onClick": moveToRight,
    "icon": createVNode(RightOutlined, null, null)
  }, {
    default: function _default() {
      return [rightArrowText];
    }
  }), createVNode(Button, {
    "type": "primary",
    "size": "small",
    "disabled": disabled || !leftActive,
    "onClick": moveToLeft,
    "icon": createVNode(LeftOutlined, null, null)
  }, {
    default: function _default() {
      return [leftArrowText];
    }
  })]);
};

Operation.inheritAttrs = false;
export default Operation;